import { createStore } from 'vuex'
import auth from './modules/auth'
import permission from './modules/permission'
import operationLog from './modules/operationLog'

const store = createStore({
  modules: {
    auth,
    permission,
    operationLog
  },
  
  // 严格模式，在开发环境下启用
  strict: process.env.NODE_ENV !== 'production'
})

export default store
